import React from 'react';
import './About.css';

const About = () => {
    return (
        <div className="about-page">
            <header className="about-hero">
                <div className="container">
                    <h1>About RiyaMaga</h1>
                    <p>Sri Lanka's Emerging Premier Vehicle Marketplace</p>
                </div>
            </header>

            <section className="about-content">
                <div className="container">
                    <div className="about-grid">
                        <div className="about-section">
                            <div className="section-icon"><i className="fa-solid fa-rocket"></i></div>
                            <h2>Our Mission</h2>
                            <p>
                                At RiyaMaga, our mission is to simplify the vehicle buying and selling process for all Sri Lankans.
                                We provide a transparent, secure, and user-friendly platform that connects genuine buyers with trusted sellers,
                                ensuring a seamless experience from browsing to ownership.
                            </p>
                        </div>

                        <div className="about-section">
                            <div className="section-icon"><i className="fa-solid fa-star" style={{ color: '#fbbf24' }}></i></div>
                            <h2>Why RiyaMaga?</h2>
                            <p>
                                We noticed that the vehicle market in Sri Lanka needed a more modern, faster, and mobile-responsive solution.
                                RiyaMaga was built with the latest technology to ensure that listing an ad takes minutes, and finding your
                                dream car takes even less.
                            </p>
                        </div>
                    </div>

                    <div className="features-highlight">
                        <h2>What We Offer</h2>
                        <div className="features-grid">
                            <div className="feature-item">
                                <h3><i className="fa-solid fa-car" style={{ color: 'var(--color-accent)', marginRight: '0.5rem' }}></i> Wide Selection</h3>
                                <p>From brand new luxury SUVs to reliable used motorbikes, we have it all.</p>
                            </div>
                            <div className="feature-item">
                                <h3><i className="fa-solid fa-camera" style={{ color: 'var(--color-accent)', marginRight: '0.5rem' }}></i> Detailed Listings</h3>
                                <p>High-quality images and full specifications to help you make informed decisions.</p>
                            </div>
                            <div className="feature-item">
                                <h3><i className="fa-solid fa-location-dot" style={{ color: 'var(--color-accent)', marginRight: '0.5rem' }}></i> Local Focus</h3>
                                <p>Find vehicles exactly where you are with our location-based filtering.</p>
                            </div>
                            <div className="feature-item">
                                <h3><i className="fa-solid fa-bolt" style={{ color: 'var(--color-accent)', marginRight: '0.5rem' }}></i> Instant Posting</h3>
                                <p>A simple, categorized post-ad process that gets your vehicle live in seconds.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default About;
